import "angular:locale/data:fi";(globalThis.$localize ??= {}).locale = "fi";
